module.exports = __webpack_public_path__ + "img/img54.b15d8c84.png";